module.exports = __webpack_public_path__ + "img/phone.fff90049.svg";